import { LANGS, setLang, t, useLang } from '../lib/i18n';

/** Three-way language switch: RU / EN / UA. Sits in the top bar and on the sign-in page. */
export function LangSwitch() {
  const lang = useLang();
  return (
    <div className="lang-switch" role="group" aria-label={t('Язык интерфейса')}>
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          className={`lang-btn${l.code === lang ? ' active' : ''}`}
          aria-pressed={l.code === lang}
          onClick={() => setLang(l.code)}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
